'use client';
import cn from 'classnames';
import { HTMLAttributes } from 'react';

interface Props extends HTMLAttributes<HTMLDivElement> {
  title: string;
}

export default function TileData(props: Props) {
  const { children, className, title, ...rest } = props;
  return (
    <div
      className={cn(
        'flex flex-grow flex-col rounded-lg border-2 border-premium-dark bg-gray-200 px-4 py-3 dark:border-orange-900 dark:bg-dark-500 dark:text-white',
        className,
      )}
      {...rest}
    >
      <h2 className="text-lg font-light">{title}</h2>
      <div className="m-2 border-b border-premium-dark dark:border-orange-900" />
      <div className="h-full p-2 pt-0 font-light">{children}</div>
    </div>
  );
}
